// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "map-1EW7q";
export { _1 as "__esModule", _2 as "map" }
export default { "__esModule": _1, "map": _2 }
